module.exports = __webpack_public_path__ + "img/_simpla.7aa7eef2.jpg";